module.exports = __webpack_public_path__ + "static/media/Ottawa_Senators.197c2914.svg";